var Feedback = require('models/feedback');
var FeedbackView = require('views/feedback/feedback-view');

var FeedbackService = function() {
  if (FeedbackService.prototype._singleton){
    return FeedbackService.prototype._singleton;
  }

  FeedbackService.prototype._singleton = this;

  this.matchFeedback = function(feedbacks, value){
    if (!feedbacks){
      return null;
    }

    return _.find(feedbacks, function(feedback){
      return _.isEqual(feedback.match, value);
    });
  };

  this.renderFeedbackWithElementState = function(feedback, feedbackElement, feedbackState, possibleStates, callbacks){
    callbacks = callbacks || {};

    this.triggerElement = feedbackElement;
    feedbackElement.removeClass(possibleStates.join(' '));
    feedbackElement.addClass(feedbackState);

    if (feedback) {
      feedback = new Feedback(_.merge({}, feedback, { feedbackState: feedbackState }));

      if (!feedback.get('blocks')){
        if (callbacks.noFeedback){
          callbacks.noFeedback();
        }
        return;
      }

      feedbackElement.addClass(feedbackState + '-feedback-showing');
      if (callbacks.unloading) {
        callbacks.origUnloading = callbacks.unloading;
      }
      callbacks.unloading = function () {
        feedbackElement.removeClass(feedbackState + '-feedback-showing');
        if (callbacks.origUnloading) {
          callbacks.origUnloading();
        }
      };
      this.renderFeedback(feedback, callbacks);
    } else {
      if (callbacks.noFeedback){
        callbacks.noFeedback();
      }
    }
  };

  this.renderFeedback = function(feedback, callbacks) {
    Chaplin.mediator.publish('block:feedback', feedback, callbacks);
  };

  this.displayFeedback = function(view, feedback, callbacks){
    var viewOptions = {
      model: feedback,
      script: view.script ? view.script.feedback : undefined,
      callbacks: callbacks,
      containerMethod: feedback.get('replace') ? 'html' : 'append'
    };

    if (feedback.get('region')){
      view.registerRegion(feedback.get('region'), '.' + feedback.get('region'));
      viewOptions.region = feedback.get('region');
    } else if(feedback.get('inline') && this.triggerElement) {
      var inlineFeedback = view.subviewsByName['inline-feedback'];
      if(inlineFeedback !== undefined) {
          inlineFeedback.$el.parent().detach().appendTo(this.triggerElement);
      } else {
        $('<div class="inline-feedback"></div>').appendTo(this.triggerElement);
        view.registerRegion('inline-feedback', '.inline-feedback');
      }
      viewOptions.region = 'inline-feedback';
    }

    var feedbackView = new FeedbackView(viewOptions);
    view.subview(feedbackView.region, feedbackView);

    view.listenTo(feedbackView, 'feedback:close', function(subview){
      subview.container.attr('role', '');
      view.removeSubview(subview);
      if(callbacks && callbacks.afterRemoved) {
        callbacks.afterRemoved();
      }
    });

    view.listenTo(feedback, 'change:state', (model, state) => {
      if (state === 'loaded') {
        feedbackView.play();
      }
    });
  };
};

module.exports = new FeedbackService();
